import React from 'react'

import styled from '@emotion/styled'
import { text, black03, mq, grayBorder } from '../../../_style'
import BackToLineupBtn from '../../atoms/lineupDetail/backToLineupBtn';
import BtnBlank from '../../atoms/btnBlank';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 120px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${grayBorder};
  font-size: 0;
  text-align: center;
  ${mq.sp} {
    margin-bottom: 60px;
  }
`
export default class BottomBtns extends React.Component {
  render() {
    return(
      <Container>
        {/* <BackToLineupBtn></BackToLineupBtn> */}
        <BtnBlank href={this.props.productInfo}>製品情報サイトへ</BtnBlank>
      </Container>
    )
  }
}
